import { render, staticRenderFns } from "./TotalOrdersCard.vue?vue&type=template&id=1321f111&lang=html&"
import script from "./TotalOrdersCard.vue?vue&type=script&lang=js&"
export * from "./TotalOrdersCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports